export const MENU_FILE_TYPES = 'image/png, image/jpeg, application/pdf, image/webp';
export const IMAGE_FILE_TYPES = 'image/png, image/jpeg, image/webp';
export const GATSBY_IMAGE_MIME_TYPES = 'image/png, image/jpeg, image/webp';
